/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Property_UpdatedInputs */

const cs_enum_property_updated = /** @type {(inputs: Enum_Property_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nemovitost upravena`)
};

const en_enum_property_updated = /** @type {(inputs: Enum_Property_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Property updated`)
};

/**
* | output |
* | --- |
* | "Property updated" |
*
* @param {Enum_Property_UpdatedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_property_updated = /** @type {((inputs?: Enum_Property_UpdatedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Property_UpdatedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_property_updated(inputs)
	return cs_enum_property_updated(inputs)
});